export default "__VITE_ASSET__D0yZ_f2E__"